const SPORTS_DATA_LIVE_MATCH_PAGES = 'base-tab-page';

export const isSportsDataLiveMatchPage = () => document?.body.classList.contains(SPORTS_DATA_LIVE_MATCH_PAGES);

const LIVEBLOG_CLASSNAME = '.lvbg-liveblog';

export const onLiveblogVisibility = (callback: (isVisible: boolean) => void) => {
  const $tabsMenu = document?.querySelector(LIVEBLOG_CLASSNAME) as HTMLElement | null;

  if ($tabsMenu) {
    if ($tabsMenu.offsetParent === null) {
      callback(false);
    } else {
      callback(true);
    }
  } else {
    callback(false);
  }
};
